import { useAclInfo } from '../useAclInfo.ts';
import { useIsAllowed } from '../useIsAllowed.ts';
import { useSession } from '../useSession.ts';

import type { PermissionConfig } from './PermissionContext.tsx';

export const permissionConfig: PermissionConfig = {
  useAclInfo,
  useIsAllowed,
  useSession,
};
